export default "<div [hidden]=\"!loading\" id=\"loader\">\n  <img src=\"../../../../assets/spinner.gif\" alt=\"loader\">\n</div>";